(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/temadagar.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/temadagar.js');
"use strict";


const themeDaysByDate = {
  themeDays: {
    2: {
      14: ['Alla hjärtans dag']
    },
    3: {
      8: ['Internationella kvinnodagen']
    },
    4: {
      3: ['Kärlekens dag'],
      30: ['Valborgsmässoafton']
    },
    5: {
      11: ['Chokladbollens dag']
    },
    6: {
      5: ['Alla vänners dag'],
      6: ['Sveriges nationaldag']
    },
    8: {
      1: ['Alla flickvänners dag']
    },
    9: {
      29: ['Kaffets dag', 'Trissens dag']
    },
    10: {
      3: ['Alla pojkvänners dag'],
      4: ['Kanelbullens dag'],
      31: ['Grannens dag', 'Halloween']
    },
    11: {
      7: ['Kladdkakans dag'],
      19: ['Internationella mansdagen']
    },
    12: {
      13: ['Lucia'],
      24: ['Julafton'],
      31: ['Nyårsafton']
    }
  },
  ruleDates: [{
    rules: ['EASTER', '-47'],
    names: ['Fettisdagen']
  }, {
    rules: ['2', '0', '4'],
    names: ['Fössta Tossdan i Mass']
  }, {
    rules: ['2', '-1', '0'],
    names: ['Sommartid']
  }, {
    rules: ['EASTER'],
    names: ['Påskdagen']
  }, {
    rules: ['4', '-1', '0'],
    names: ['Morsdag']
  }, {
    rules: ['MIDSUMMER'],
    names: ['Midsommarafton']
  }, {
    rules: ['9', '0', '0'],
    names: ['Gräddtårtans dag']
  }, {
    rules: ['9', '-1', '0'],
    names: ['Vintertid']
  }, {
    rules: ['ALL_SAINTS_DAY'],
    names: ['Alla helgons dag']
  }, {
    rules: ['10', '1', '0'],
    names: ['Fars dag']
  }]
};
const {
  isLeapYear
} = svs.tickets_giftshop.gift.giftform.date_selector.components.util;
const isLeapYearAffectingDate = date => date.getMonth() === 1 && date.getDate() > 27;
const formatDate = date => "".concat(date.getMonth() + 1, "-").concat(date.getDate());
const isLastDayOfMonthRule = week => week < 0;
const isEqualOrGreaterThan = function (themeDate) {
  let currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(Date.now());
  themeDate.setHours(23, 59, 0, 0);
  return themeDate > currentDate;
};

const getDateByWeekAndWeekday = (year, month, week, day) => {
  const firstDay = 1;
  const date = new Date(year, month, week * 7 + firstDay, 12);
  if (date.getDay() === day) {
    return isEqualOrGreaterThan(date) ? date : getDateByWeekAndWeekday(year + 1, month, week, day);
  }
  if (date.getDay() >= day) {
    day += 7;
  }
  date.setDate(date.getDate() - date.getDay() + day);
  return isEqualOrGreaterThan(date) ? date : getDateByWeekAndWeekday(year + 1, month, week, day);
};

const getLastWeekdayInMonth = (year, month, dayOfWeek) => {
  const date = new Date(year, month + 1, 0, 12);
  date.setDate(date.getDate() - (date.getDay() + 7 - dayOfWeek) % 7);
  return isEqualOrGreaterThan(date) ? date : getLastWeekdayInMonth(year + 1, month, dayOfWeek);
};

const calculateEaster = (year, incrementOrDecrement) => {
  const C = Math.floor(year / 100);
  const N = year - 19 * Math.floor(year / 19);
  const K = Math.floor((C - 17) / 25);
  let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
  I = I - 30 * Math.floor(I / 30);
  I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
  let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
  J = J - 7 * Math.floor(J / 7);
  const L = I - J;
  const M = 3 + Math.floor((L + 40) / 44);
  const D = L + 28 - 31 * Math.floor(M / 4);
  const date = new Date(Date.now());
  date.setFullYear(year);
  date.setMonth(M - 1);
  date.setDate(D);
  date.setDate(date.getDate() + parseInt(incrementOrDecrement, 10));
  if (isLeapYear(year) && isLeapYearAffectingDate(date)) {
    date.setDate(date.getDate());
  }
  return isEqualOrGreaterThan(date) ? date : calculateEaster(year + 1, incrementOrDecrement);
};

const firstOfWeekdayAfterDate = (weekday, refDate) => {
  const plusDays = (d, days) => {
    const date = new Date(d);
    date.setDate(date.getDate() + (days || 0));
    return date;
  };
  return plusDays(refDate, (refDate.getDay() > weekday ? 7 : 0) - refDate.getDay() + weekday);
};

const getDate = function () {
  let rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(Date.now()).getFullYear();
  if (rules.includes('MIDSUMMER')) {
    return firstOfWeekdayAfterDate(5, new Date(year, 5, 19));
  }
  if (rules.includes('ALL_SAINTS_DAY')) {
    return firstOfWeekdayAfterDate(6, new Date(year, 9, 31));
  }
  if (rules.includes('EASTER')) {
    const [, incrementOrDecrement = 0] = rules;
    return calculateEaster(year, incrementOrDecrement);
  }
  const [month, week, day] = rules.map(v => parseInt(v, 10));
  if (isLastDayOfMonthRule(week)) {
    return getLastWeekdayInMonth(year, month, day);
  }
  return getDateByWeekAndWeekday(year, month, week, day);
};
const addThemedayByDate = function (themeDaysByDate, date) {
  var _themeDaysByDate$mont;
  let names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const [monthKey, dayKey] = date.split('-');
  if (!themeDaysByDate[monthKey]) {
    themeDaysByDate[monthKey] = {
      [dayKey]: []
    };
  }
  if (((_themeDaysByDate$mont = themeDaysByDate[monthKey][dayKey]) === null || _themeDaysByDate$mont === void 0 ? void 0 : _themeDaysByDate$mont.length) > 0) {
    themeDaysByDate[monthKey][dayKey] = themeDaysByDate[monthKey][dayKey].concat(names);
    return themeDaysByDate;
  }
  themeDaysByDate[monthKey][dayKey] = names;
  return themeDaysByDate;
};

const parseThemeDaysByDate = function () {
  let themeDaysData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeDaysByDate;
  return themeDaysData.ruleDates.reduce((_ref, _ref2) => {
    let {
      themeDays
    } = _ref;
    let {
      rules,
      names
    } = _ref2;
    const date = getDate(rules, new Date(Date.now()).getFullYear());
    const maxDate = new Date(Date.now());
    maxDate.setFullYear(maxDate.getFullYear() + 1);
    if (date > maxDate) {
      return {
        themeDays
      };
    }
    const formattedDate = formatDate(date);
    const trimmedNames = names.map(n => n.trim());
    return {
      themeDays: addThemedayByDate(themeDays, formattedDate, trimmedNames)
    };
  }, themeDaysData);
};
svs.tickets_giftshop.gift.giftform.date_selector.themeDays = {
  getDate: (rules, year) => formatDate(getDate(rules, year)),
  getThemeDays: themeDaysData => parseThemeDaysByDate(themeDaysData).themeDays || {}
};

 })(window);